module.exports = __webpack_public_path__ + "static/media/0024_IMG_TRAD_LES_MURS_PAPIER_BRIQUE_BLANCHE.dc35b73a.png";